// extracted by mini-css-extract-plugin
export default {"btn":"SMLButton_btn__MYPjy","primary":"SMLButton_primary__Qow4r","follow":"SMLButton_follow__Jhbwn","following":"SMLButton_following__dtllr"};